import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { X, ChevronRight } from "lucide-react";
import Vertical_1 from "../../assests/images/vertical_1.jpg";
import Vertical_2 from "../../assests/images/vertical_2.jpg";
import Horizontal_4 from '../../assests/images/horizontal_4.jpg';
import { sendEventEmail } from "../../services/firestore/fireSideChatService";

const categories = ["All"];

const events = [
  {
    id: 1,
    title: "ASME x Standard Chartered x Nextloop",
    date: "Q2 2026",
    venue: "Standard Chartered Marina Bay Financial",
    image: Vertical_1,
    description: "Coming Soon",
    timeline: [
      { time: "", activity: "Coming Soon" },
    ],
  },
  {
    id: 2,
    title: "ASME x Knight Frank x Nextloop",
    date: "Q2 2026",
    venue: "Ocean Financial Centre",
    image: Vertical_2,
    description:
      "Coming Soon",
      timeline: [
      { time: "", activity: "Coming Soon" },
    
    ],
  },
  {
    id: 3,
    title: "Youth Business Summit",
    date: "Q1 2027",
    venue: "TBC",
    image: Horizontal_4,
    description:
      "Coming Soon",
      timeline: [
      { time: "", activity: "Coming Soon" },
    
    ],
  },
];

export default function SecondSection({ onRegisterInterest }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showThankYou, setShowThankYou] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (inView) controls.start("visible");
  }, [controls, inView]);

  return (
    <>
      <motion.section
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
        }}
        className="w-full bg-[#121212] text-white py-16 px-6 lg:px-12"
      >
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-12">
          <div>
            <h2 className="text-4xl lg:text-5xl font-semibold leading-tight">
              Upcoming <span className="text-[#92abc4]">Events</span>
            </h2>
            {/* <div className="flex flex-wrap gap-4 mt-6 text-gray-400 text-sm">
              {categories.map((cat, i) => (
                <button
                  key={i}
                  className={`${i === 0 ? "text-white" : "hover:text-white"} transition`}
                >
                  {cat}
                </button>
              ))}
            </div> */}
          </div>
          <button onClick={onRegisterInterest} className="mt-6 lg:mt-0 bg-[#92abc4] text-white px-6 py-2 rounded-full hover:bg-[#3d946b] transition">
            Register your interest
          </button>
        </div>

        {/* Horizontal Scrollable Cards */}
        <div className="relative w-full overflow-x-auto overflow-y-hidden scrollbar-hide h-[490px] sm:h-[500px] md:h-[520px]">
          <div className="inline-flex gap-8 min-w-max overflow-y-hidden scroll-snap-x">
            {events.map((event) => (
              <motion.div
                key={event.id}
                className="relative w-[300px] lg:w-[350px] rounded-3xl flex-shrink-0"
              >
                {/* Image with gradient overlay */}
                <div className="relative w-full h-[480px] overflow-hidden rounded-3xl group">
  <img
    loading="lazy"
    src={event.image}
    alt={event.title}
    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
  />

  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

  {/* Text + CTA */}
  <div className="absolute bottom-6 left-6 right-6">
    <h3 className="text-2xl font-semibold">{event.title}</h3>
    <p className="text-sm mt-1 text-gray-300">{event.date}</p>
    <p className="text-sm text-gray-300">{event.venue}</p>

    {/* CTA row */}
    <div className="mt-4 flex justify-end">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setSelectedEvent(event);
        }}
        className="bg-white text-black px-4 py-2 rounded-full text-sm font-medium hover:scale-105 transition"
      >
        Register your interest
      </button>
    </div>
  </div>
</div>

              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* POPUP MODAL */}
     {/* POPUP MODAL */}
{/* POPUP MODAL */}
{selectedEvent && (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className="fixed inset-0 bg-black/70 backdrop-blur-md flex justify-center items-center z-50 p-4"
  >
    <motion.div
      initial={{ scale: 0.85, opacity: 0, y: 20 }}
      animate={{ scale: 1, opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 160, damping: 20 }}
      className="bg-[#1c1c1c] text-white max-w-lg w-full p-6 sm:p-8 rounded-2xl relative max-h-[90vh] overflow-y-auto"
    >
      <button
        className="absolute top-4 right-4 text-gray-400 hover:text-white"
        onClick={() => setSelectedEvent(null)}
      >
        <X size={24} />
      </button>

      <h2 className="text-3xl font-bold">{selectedEvent.title}</h2>
      <p className="text-gray-300 mt-2">{selectedEvent.date}</p>
      <p className="text-gray-300">{selectedEvent.venue}</p>
      <p className="mt-6 leading-relaxed text-gray-400">{selectedEvent.description}</p>

      {/* Timeline */}
      {selectedEvent.timeline && (
        <div className="mt-8">
          <h3 className="text-xl font-semibold mb-4">Event Timeline</h3>
          <ul className="relative border-l border-gray-600 ml-4">
            {selectedEvent.timeline.map((item, index) => (
              <li key={index} className="mb-6 ml-4">
                <span className="absolute w-3 h-3 bg-[#2F7C57] rounded-full -left-1.5 border border-gray-800"></span>
                <p className="text-gray-300 font-medium">{item.time}</p>
                <p className="text-gray-400">{item.activity}</p>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Email Registration */}
      <div className="mt-8">
        <h3 className="text-xl font-semibold mb-4">Register Your Interest</h3>
        <form
        className="flex flex-col sm:flex-row gap-4"
        onSubmit={async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    await sendEventEmail({
      type: "interest",
      email,
      title: selectedEvent.title,
      eventDate: selectedEvent.date,
      eventLocation: selectedEvent.venue
    });

    setShowThankYou(true);
    setEmail("");
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
}}

      >
        <input
          type="email"
          placeholder="Your email address"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 px-4 py-2 rounded-full bg-[#2a2a2a] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2F7C57]"
        />

        <button
  type="submit"
  disabled={loading}
  className={`px-6 py-2 rounded-full transition text-white 
    ${loading ? "bg-gray-600 cursor-not-allowed" : "bg-[#2F7C57] hover:bg-[#3d946b]"}
  `}
>
  {loading ? "Sending..." : "Submit"}
</button>
        </form>
      </div>
    </motion.div>
  </motion.div>
)}

{showThankYou && (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.8 }}
    className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
  >
    <motion.div
      className="bg-[#1c1c1c] text-white max-w-sm w-full p-6 rounded-2xl text-center"
      transition={{ type: "spring", stiffness: 160, damping: 20 }}
    >
      <h2 className="text-2xl font-bold mb-4">Thank You!</h2>
      <p className="text-gray-300 mb-6">We’ve received your interest. You’ll be updated via email soon!</p>
      <button
        onClick={() => setShowThankYou(false)}
        className="bg-[#2F7C57] px-6 py-2 rounded-full text-white hover:bg-[#3d946b] transition"
      >
        Close
      </button>
    </motion.div>
  </motion.div>
)}



    </>
  );
};

